export function getCurrency(currencyId) {
  return fetch(`${process.env.REACT_APP_BASE_API_URL}/Currency/List`).then(
    (data) => {
      return data.json();
    }
  );
}
